import React from 'react';
import { Spinner } from '@pearsontechnology/aero-components';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default () => <Wrapper><Spinner small /></Wrapper>;
